import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {getUserId} from '@/services/internal/user/getUserId';
import {USER_ID_HEADER} from '@/utils/constant';

export default async function abortMatch(data: string, isCash: boolean, gameId: string) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();
  try {
    await fetch('/api/report-score', {
      method: 'PATCH',
      body: JSON.stringify({
        data,
        state: 'ABORTED',
        abortState: 'INTENTIONAL',
        isCash,
        gameId,
      }),
      headers,
    });
  } catch (e) {
    console.log('failure to abort match:', e, 'match data:', data);
    throw e;
  }
}
